export enum ExpressPassContext {
  eExpressContextNone = 0,
  eExpressContextBaseProduct = 1, // Binary 001 -> Without Attraction selection
  eExpressContextVariantProduct = 2, // Binary 010 -> After Attraction selection
  eExpressContextMainProduct = 4, // Binary 100 // USJT-9499: If the the attribute productVariantSelector is set to "MULTI_SELECT" then the express pass does not has any variant selection
}
